import React from "react";

const DynamicTable = ({
  tableData,
  handleInputChange,
  handleAddRow,
  handleDeleteRow,
  handleFocus,
  inputRefs,
  isReadOnly,
  columns,
  actionsEnabled = true,
  liftStyleInventory = [],
  fabrics = [],
  inventory = [],
}) => {
  return (
    <div className="table-responsive" style={{ overflowX: "auto" }}>
      <table className="table table-bordered table-sm table-hover">
        <thead>
          <tr>
            <th className="border-end border-light text-uppercase text-center">
              Index
            </th>
            {columns.map((column, colIndex) => (
              <th
                key={colIndex}
                className={`border-end border-light text-uppercase ${column.className || ""
                  }`}
              >
                {column.header}
              </th>
            ))}
            {actionsEnabled && (
              <th className="border-light text-uppercase">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, rowIndex) => {
            const headrailConfig = inventory?.find(
              (item) => item._id === row.productHeadrail
            );
            return (
              <tr key={rowIndex}>
                <td className="p-1 text-center align-middle">{rowIndex + 1}</td>
                {columns.map((column, colIndex) => (
                  <td className="p-1" key={colIndex}>
                    {column.key === "liftStyle" ? (
                      <select
                        name="liftStyle"
                        className="form-control"
                        value={row.liftStyle || ""}
                        onChange={(e) =>
                          handleInputChange(rowIndex, column.key, e.target.value)
                        }
                      >
                        {!row.liftStyle && (
                          <option value="">---Select Lift Style---</option>
                        )}
                        {liftStyleInventory
                          .filter((style) => style.category === "Lift_hardware")
                          .map((style) => (
                            <option key={style._id} value={style._id}>
                              {style.name}
                            </option>
                          ))}
                        <option value="">---Select Motor---</option>
                        {liftStyleInventory
                          .filter((style) => style.category === "Motor")
                          .map((style) => (
                            <option key={style._id} value={style._id}>
                              {style.name}
                            </option>
                          ))}
                      </select>
                    ) : column.key === "productMaterial" ? (
                      <select
                        name="productMaterial"
                        className="form-control"
                        value={row.productMaterial || ""}
                        onChange={(e) =>
                          handleInputChange(rowIndex, column.key, e.target.value)
                        }
                      >
                        {!row.productMaterial && (
                          <option value="">---Select Fabric---</option>
                        )}
                        {fabrics.map((fabric) => (
                          <option key={fabric._id} value={fabric._id}>
                            {fabric.name}
                          </option>
                        ))}
                      </select>
                    ) : column.key === "productHeadrail" ? (
                      <select
                        name="productHeadrail"
                        className="form-control"
                        value={row.productHeadrail || ""}
                        onChange={(e) =>
                          handleInputChange(rowIndex, column.key, e.target.value)
                        }
                      >
                        {!row.productHeadrail && (
                          <option value="">---Select Headrail---</option>
                        )}
                        {inventory &&
                          inventory.length > 0 &&
                          inventory.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                    ) : column.key === "sleeveOption" ? (
                      headrailConfig?.config?.headrail?.sleeveOn?.isTrue ? (
                        <select
                          className="form-select"
                          value={row.sleeveOption || "off"}
                          onChange={(e) =>
                            handleInputChange(rowIndex, column.key, e.target.value)
                          }
                        >
                          <option value="off">Sleeve Off</option>
                          <option value="on">Sleeve On</option>
                        </select>
                      ) : (
                        <div className="text-center w-100">N/A</div>
                      )
                    ) : (
                      <input
                        type="text"
                        className={`form-control border-light ${column.inputClass}`}
                        style={{ width: column.width || "auto" }}
                        value={row[column.key]}
                        onChange={(e) =>
                          handleInputChange(rowIndex, column.key, e.target.value)
                        }
                        onFocus={(e) => {
                          if (handleFocus && column.focusable) {
                            handleFocus(rowIndex, column.key);
                            e.target.scrollIntoView({ behavior: "smooth" });
                          }
                        }}
                        ref={(el) =>
                          inputRefs &&
                          (inputRefs.current[rowIndex] = {
                            ...inputRefs.current[rowIndex],
                            [column.key]: el,
                          })
                        }
                        readOnly={
                          column.key === "width" || column.key === "height"
                            ? isReadOnly
                            : column.readOnly || false
                        }
                        disabled={column.disabled || false}
                      />
                    )}
                  </td>
                ))}
                {actionsEnabled && (
                  <td className="text-center align-middle">
                    <button
                      type="button"
                      className="btn btn-success me-2"
                      onClick={() => handleAddRow(rowIndex)}
                    >
                      <i className="bi bi-plus-circle fs-5 text-white"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleDeleteRow(rowIndex)}
                    >
                      <i className="bi bi-trash fs-5 text-white"></i>
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable;